import { Alert, Box, Button, Link, Stack, TextField, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink, useHistory, useLocation } from 'react-router-dom';
import AccountCard, { MockupStateLinks, accountBodySx, accountLinkSx } from '../components/AccountCard';
import { primaryButtonSx } from '../publicStyles';

const BASE = '/mockup/public/forgot-password';

// Proposal for /reset_password_email (now implemented). The confirmation is worded so it does not
// reveal whether an account exists for the address, matching the API's single generic answer.
export default function PublicForgotPasswordPage() {
    const history = useHistory();
    const location = useLocation();
    const sentTo = new URLSearchParams(location.search).get('sent');
    const [email, setEmail] = React.useState('');

    if (sentTo !== null) {
        return (
            <AccountCard title="Check your email"
                controls={<Controls current={`${BASE}?sent=${encodeURIComponent(sentTo)}`} sentTo={sentTo} />}>
                <Alert severity="success" role="status" sx={{ mt: 2, borderRadius: '12px' }}>
                    Reset email preview for {sentTo || 'your address'}. Nothing was sent from this mockup.
                </Alert>
                <Typography sx={{ ...accountBodySx, mt: 2 }}>
                    If an account uses that address, you&apos;ll get an email with a link to choose a new password within
                    15 minutes. The link works once and expires in 1 hour. Check your spam folder if it doesn&apos;t arrive.
                </Typography>
                <Stack spacing={1} sx={{ mt: 3 }}>
                    <Button component={RouterLink} to="/mockup/public/login" sx={{ ...primaryButtonSx, minHeight: 48 }}>Back to log in</Button>
                    <Button component={RouterLink} to={BASE} variant="text">Use a different email</Button>
                </Stack>
            </AccountCard>
        );
    }

    return (
        <AccountCard title="Forgot your password?" intro="Enter the email address you use for VerbaSchola and we'll send you a link to choose a new password."
            controls={<Controls current={BASE} sentTo="maya.chen@example.edu" />}>
            <Stack component="form" spacing={2} sx={{ mt: 3 }}
                onSubmit={(event: React.FormEvent) => { event.preventDefault(); history.push(`${BASE}?sent=${encodeURIComponent(email)}`); }}>
                <TextField label="Email address" name="email" type="email" autoComplete="email" autoFocus required fullWidth
                    value={email} onChange={event => setEmail(event.target.value)} />
                <Button type="submit" sx={{ ...primaryButtonSx, minHeight: 48 }}>Send reset link</Button>
            </Stack>
            <Box sx={{ textAlign: 'center', mt: 3 }}>
                <Link component={RouterLink} to="/mockup/public/login" underline="hover" sx={accountLinkSx}>Back to log in</Link>
            </Box>
        </AccountCard>
    );
}

function Controls({ current, sentTo }: { current: string; sentTo: string }) {
    return <MockupStateLinks current={current} options={[
        { label: 'Request form', to: BASE },
        { label: 'Email sent', to: `${BASE}?sent=${encodeURIComponent(sentTo)}` },
    ]} />;
}
